var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('step-base',{attrs:{"step":_vm.step}},[(_vm.step.currentPage == _vm.stPgNo.CA.CounterApplication)?_c('counter-application',{attrs:{"step":_vm.step}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }